<template>
  <div class="general">
    <div class="general-item">
      <jContentBox :title="title1">
        <div slot="boxBody" class="imageMap">
        </div>
      </jContentBox>
    </div>

    <div class="general-item">
      <jContentBox :title="title2">
        <div slot="boxBody" id="chart">
        </div>
      </jContentBox>
    </div>
  </div>
</template>

<script>
  import jContentBox from '../../components/jContentBox.vue'

  export default {
    data() {
      return {
        title1: '土地流转面积占比分析',
        title2: '各土地流转模式流转比率分析',
        tabPosition: '等级',
//        options: [{
//          value: '默认'
//        }, {
//          value: '默认2'
//        }]
      }
    },
    methods: {
      initChart() {
        let myEcahrt = this.$echarts.init(document.getElementById('chart'));
        console.log(myEcahrt)
        let option = {
          tooltip: {
            show: true,
            formatter: function (params) {
              var html = '';
              return html += '<p style="font-size:28px;margin-bottom:10px;text-align:center;width:70px;color:' +
                params.color +
                ';">' +
                params.percent +
                '<span style="color:#C8470A;font-size:20px;">%</span></p>'
            },
            position: ['45%', '45%'],
            backgroundColor: 'none',
          },
          color: ['#26adee', '#53c6e8', '#48e3fb', '#dc802e', '#c8470a', '#1e56f6', '#0b83f3'],
          series: [
            {
              z: 0,
              name: '',
              type: 'pie',
              center: ['48%', '40%'],
              radius: [74, 75],
            },
            {
              name: '',
              type: 'pie',
              radius: ['50', '90'],
              center: ['50%', '47%'],

              data: [{
                value: 335,
                name: '农村土地互换',
              }, {
                value: 221,
                name: '农村土地出租'
              }, {
                value: 458,
                name: '农村土地股份合作'
              },
                {
                  value: 355,
                  name: '农村土地入股'
                }, {
                  value: 458,
                  name: '农村土地转包'
                },
                {
                  value: 545,
                  name: '宅基地换住房，承包地换社保'
                }],
              label: {
                normal: {
                  position: 'outside',
                  show: true,
                  formatter: "{b}\n流转面积：{c}(万亩)\n占比：{d}",
                  textStyle: {
                    fontSize: 14,
                    color: '#fff'
                  }
                }
              },
              labelLine: {
                normal: {
                  length: 30,
                  length2: 10,
                }
              }
            }
          ]
        };
        myEcahrt.setOption(option);
        console.log(111)
      }
    },
    components: {jContentBox},
    mounted() {
      this.initChart();
    }
  }
</script>

<style lang="scss" scoped>
  .general {
    width: 100%;
    height: 433px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .general-item {
      width: calc((100% - 20px) / 2);
      height: 100%;
    }
    .imageMap {
      background: url('../../../static/img/areaspread.png') no-repeat center center;
      background-size: contain;
      width: 100%;
      height: calc(100% - 30px);
    }
    #chart {
      width: 100%;
      height: calc(100% - 30px);
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/transaction/proportion.vue